/* eslint-disable eqeqeq */
import { Modal, notification } from "antd";
import React, { FC, useState } from "react";
import { APIS } from "../../../../constants/apis";
import API from "../../../../services/api.service";
import style from "./style.module.scss";
import { nth, month } from "../../../../utils/helper";

export interface maintenancecard {
  data?: any;
  onupdate: Function;
}

const UpcomingMaintanenceCard: FC<maintenancecard> = ({ data, onupdate }) => {
  const [deleteModal, setDeleteModal] = useState(false);
  const [showMenu, setShowMenu] = useState(false);

  const deleteMaintenence = async () => {
    const res = await API.delete(
      APIS.USER_MANAGEMENT.DELETE_MAINTENANCE_DAY + data.id
    );
    if (res.data.status == 1) {
      onupdate();
      setDeleteModal(false);
      notification.success({
        message: "Maintenance deleted successfully",
        placement: "top",
      });
    } else {
      notification.error({
        message: res.data.message || "Failed to delete maintenance",
        placement: "top",
      });
    }
  };

  return (
    <>
      <div className={style.visit_card}>
        <div className={style.visit_container}>
          <div className={style.upcoming_}>
            <div className={style.name}>Scheduled Date</div>
            <div className={style.date}>
              <img src="/images/home/calendar.svg" alt="" />
              {new Date(data.date).getUTCDate()}
              {nth(new Date(data.date).getUTCDate())}{" "}
              {month[new Date(data.date).getMonth()]}{" "}
              {new Date(data.date).getFullYear()}
            </div>
          </div>
          <div className={style.menu_list_show}>
            <div
              className={style.menu_list}
              onClick={() => {
                setDeleteModal(true);
                setShowMenu(false);
              }}
            >
              <span>
                <img
                  src="/images/delete.svg"
                  className={style.img_icon}
                  alt={""}
                />
              </span>
            </div>
          </div>
        </div>
        {data.remarks && (
          <>
            {/* <div className={style.divider}></div> */}
            <div className={style.contact}>
              <div className={style.name}>Remarks</div>
              <div className={style.remarks_text}>{data.remarks}</div>
            </div>
          </>
        )}
      </div>

      {/* Delete Confirmation Modal */}
      <Modal
        visible={deleteModal}
        footer={null}
        onCancel={() => setDeleteModal(false)}
        keyboard={true}
      >
        <div className={style.modal_delete}>
          <div className={style.modal_header}>Delete Maintenance</div>
          <div className={style.modal_content}>
            Are you sure you want to delete this maintenance schedule? This
            action cannot be undone.
          </div>
          <div className={style.modal_btns}>
            <div className={style.cancel} onClick={() => setDeleteModal(false)}>
              Cancel
            </div>
            <div className={style.delete} onClick={deleteMaintenence}>
              Delete
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default UpcomingMaintanenceCard;
